import React from 'react'
import { graphql } from 'gatsby'
import BlockReturn from '../../function/ReturnBlock'
import Layout from '../../components/layout'
import Seo from '../../components/seo'
import generateBreadcrumbs from '../../function/generateBreadcrumbs'
function ServiceSingle({ data, pageContext }) {
    const blocks = data?.service?.blocks
    const serviceSettings =  data?.settings?.service?.serviceSettings || {}
    const { title, sectors } = data?.service
    if (blocks[0]?.name === undefined || blocks?.length === 0) {
        return (
            <Layout mode={pageContext?.theme ? 'light' : 'dark'}>
                <div
                    className="container"
                    style={{
                        textAlign: 'center',
                        fontSize: '35px',
                        lineHeight: '35px',
                        fontWeight: '700',
                        margin: '70px auto'
                    }}
                >
                    Page don't have content, please add content from WP editor
                </div>
            </Layout>
        )
    } else {
        return (
            <Layout mode={pageContext?.theme ? 'light' : 'dark'}>
                <div className={`mx-auto ${pageContext?.slug}`}>
                    {blocks?.length > 0 && (
                        <BlockReturn
                            blocks={blocks}
                            serviceSettings={{
                                ...serviceSettings,
                                title,
                                sectors
                            }}
                            type={pageContext?.type}
                        />
                    )}
                </div>
            </Layout>
        )
    }
}
export const Head = ({ data, pageContext }) => {
    const { seo, title, excerpt, featuredImage } = data?.yoastSeo
    const metaDesc =
        seo?.metaDesc ||
        excerpt.replace(/<[^>]*>/g, '') ||
        `Celerity service | ${title}`
    const breadcrumbs = generateBreadcrumbs(pageContext?.breadcrumbs)
    return (
        <Seo
            title={seo?.title}
            description={metaDesc}
            image={featuredImage?.node?.sourceUrl}
            props={seo}
            breadcrumbs={breadcrumbs}
        />
    )
}

export default ServiceSingle
export const query = graphql`
    query ($id: String!, $slug: String!) {
        service: wpService(id: { eq: $id }) {
            ...ServiceLayout
            title
            sectors {
                nodes {
                    name
                }
            }
        }
        settings: wpPage(slug: { eq: $slug }) {
            service {
                serviceSettings {
                    primaryColour
                    secondaryColour
                }
            }
        }
        yoastSeo: wpService(id: { eq: $id }) {
            featuredImage {
                node {
                    sourceUrl
                }
            }
            title
            excerpt
            seo {
                title
                canonical
                metaDesc
                focuskw
                opengraphTitle
                opengraphDescription
                twitterTitle
                twitterDescription
                breadcrumbs {
                    url
                    text
                }
            }
        }
    }
`
